import { render } from "./IconForesight.vue?vue&type=template&id=6770cccc"
import script from "./IconForesight.vue?vue&type=script&lang=js"
export * from "./IconForesight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__